import React, { FC } from 'react';
import config from '../../config';
import { Icon, IconName } from '@sprout-platform/ui';

export interface FooterLink {
  text: string;
  icon?: string;
  url?: string;
  target?: string;
}

export let getFooterLinks = (): FooterLink[] => {
  return [
    {
      text: 'Documentation',
      icon: 'file-alt',
      url: 'https://github.com/savantly-net/sprout-platform/',
      target: '_blank'
    },
    {
      text: 'Support',
      icon: 'question-circle',
      url: 'https://savantly.net',
      target: '_blank'
    },
    {
      text: 'Community',
      // icon: 'comments-alt',
      icon: 'comment-alt',
      url: 'https://github.com/savantly-net/sprout-platform/issues',
      target: '_blank'
    }
  ];
};

export let getVersionLinks = (): FooterLink[] => {
  const { buildInfo, licenseInfo } = config;
  const links: FooterLink[] = [];
  const stateInfo = licenseInfo.stateInfo ? ` (${licenseInfo.stateInfo})` : '';

  links.push({ text: `${buildInfo.edition}${stateInfo}`, url: licenseInfo.licenseUrl });

  if (buildInfo.hideVersion) {
    return links;
  }

  links.push({ text: `v${buildInfo.version} (${buildInfo.commit})` });

  if (buildInfo.hasUpdate) {
    links.push({
      text: `New version available!`,
      icon: 'download-alt',
      url: 'https://github.com/savantly-net/sprout-platform/releases',
      target: '_blank'
    });
  }

  return links;
};

export function setFooterLinksFn(fn: typeof getFooterLinks) {
  getFooterLinks = fn;
}

export function setVersionLinkFn(fn: typeof getFooterLinks) {
  getVersionLinks = fn;
}

export const Footer: FC = React.memo(() => {
  const links = getFooterLinks().concat(getVersionLinks());

  return (
    <footer className="footer">
      <div className="text-center">
        <ul>
          {links.map((link) => (
            <li key={link.text}>
              <a href={link.url} target={link.target} rel="noopener">
                {/* <Icon name={link.icon as IconName} /> {link.text} */}
                {link.icon !== undefined ? (
                  <>
                    <Icon name={link.icon as IconName} /> {link.text}
                  </>
                ) : (
                  (link.text != undefined) ? link.text : ''
                )}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
});
